import { render, staticRenderFns } from "./ArtistSearch.vue?vue&type=template&id=67629715&"
import script from "./ArtistSearch.vue?vue&type=script&lang=js&"
export * from "./ArtistSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports